<template>
  <div class="pco-config-status">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div v-if="Object.keys(formulario).length >= 1 && [ '', null, undefined ].indexOf(formulario.tipo) === -1">
        <RF-Componente
          :data-time='time'
          :cpntTamanho='formulario.tipo.tamanho'
          :cpntModelo='formulario.tipo.tipo'
          :cpntStatus='formulario.tipo.status'
          :cpntId='formulario.tipo.id'
          :cpntClassDivField='formulario.tipo.classDivField'
          :cpntNome='formulario.tipo.nome'
          :cpntValue='formulario.tipo.value'
          :cpntValueRef='formulario.tipo.valueRef'
          :cpntOptions='formulario.tipo.options'
          :cpntKeyValue='formulario.tipo.keyValue'
          :cpntKeyMostra='formulario.tipo.keyMostra'
          :cpntAutoComplete='formulario.tipo.autocomplete'
          :cpntDisabled='formulario.tipo.disabled'
          :cpntMostrar='formulario.tipo.mostrar'
          :cpntMensagem='formulario.tipo.mensagem'
          :cpntSelecioneNome='formulario.tipo.selecioneNome'
          :cpntSelecioneValue='formulario.tipo.selecioneValue'
          :cpntMensagemTipo='formulario.tipo.mensagemTipo'
          :cpntAdicinarOption='formulario.tipo.adicinarOption'
          :cpntMultiple='formulario.tipo.multiple'
          :cpntAllRegistro='formulario.tipo.allRegistro'
          :cpntExplica='formulario.tipo.explica'
          :cpntTabIndex='formulario.tipo.tabIndex'
          :cpntOptionInicialNome='formulario.tipo.optionInicialNome'
          :cpntOptionInicialValue='formulario.tipo.optionInicialValue'

          :cpntOnChange='formulario.tipo.onChange'
          :cpntOnBlur='formulario.tipo.onBlur'
          :ref='formulario.tipo.tipo'
        ></RF-Componente>

        <div style="float: right; margin-top: 10px; margin-right: -3px;" v-if="(formulario.tipo.optionsOriginal.filter(item => item.status !== '1').length >= 1) || tabela.linha.filter(item => item.status !== '1').length >= 1">
          Mostrar os excluídos:
          <RF-Checkbox-Tabela :data-time='time' style='position: relative; top: 0px;'
            :cpntStatus='""'
            :cpntId='"pco-config-status-excluidos"' 
            :cpntNome='""'
            :cpntValue='"excluidos"'
            :cpntChecked='mostrarExcluido === true ? [ "excluidos" ] : []'
            :cpntExplica='{ mensagem: "Marque esta opção caso deseje apresentar os possiveis status excluídos." }'

            :cpntOnChange='pcoConfigOnCheckboxMostrarExcluidos'
          ></RF-Checkbox-Tabela>
        </div>

        <div class="pco-config-status-buttons" :data-time='time'>
          <RF-Button v-for='(button, index) in formulario.buttons' :key="index"
            :data-time='time'

            :cpntStatus='button.status' 
            :cpntId='button.id' 
            :cpntTipo='button.tipo' 
            :cpntIcone='button.icone' 
            :cpntTexto='button.texto' 
            :cpntClass='button.class'
            :cpntMostrar='button.mostrar'
            :cpntTabIndex='button.tabIndex'

            @onClickButton='button.onClick'
          ></RF-Button>
        </div>
      </div>

      <!-- CRIA A TABELA -->
      <div v-if="Object.keys(tabela).length >= 1" class="pco-config-status-tab">
        <template v-if='tabela.status !== ""'>
          <RF-Status :cpntStatus='tabela.status' :cpntTamanho='5'></RF-Status>
        </template>
        <div v-if="tabela.status === ''">
          <hr/>

          <div v-if="Object.keys(buttonForm).length >= 1 && formulario.tipo.itemExcluido === false" class="pco-config-status-novo">
            <RF-Button 
              :cpntId='buttonForm.id'
              :cpntStatus='buttonForm.status' 
              :cpntTexto='buttonForm.texto' 
              :cpntClass='buttonForm.class' 

              @onClickButton='buttonForm.onClick'
            ></RF-Button>
          </div>

          <table class="tab-pco-config-status" :data-time='time'>
            <thead>
              <tr v-if="tabela.acoes.buttons.length >= 1" class="buttons">
                <th :colspan="tabela.coluna.length">
                  <template v-for='(button, index) in tabela.acoes.buttons'>
                    <RF-Button :key="index"
                      :data-time='time'

                      :cpntStatus='button.status' 
                      :cpntId='button.id' 
                      :cpntTipo='button.tipo' 
                      :cpntTexto='button.texto' 
                      :cpntClass='button.class'
                      :cpntMostrar='button.mostrar'
                      :cpntTabIndex='button.tabIndex'

                      @onClickButton='button.onClick'
                    ></RF-Button>
                  </template>
                </th>
              </tr>
              <tr class="titulos">
                <th v-for="(coluna, indexC) in tabela.coluna" :key="'col-' + indexC">
                  <template v-if="coluna.tipo === 'RF-Checkbox-Model'">
                    <RF-Checkbox-Model
                      :cpntChavesModel='coluna.chaveModel'
                      :cpntValue='coluna.chave'
                      :cpntChecked='tabela.checkboxGeral'

                      @cpntUpdateModelLocal="pcoConfigOnCheckboxUpdateModelGeral"
                      :cpntTime='time'
                    ></RF-Checkbox-Model>
                  </template>
                  <span v-else v-html="coluna.nome"></span>
                </th>
              </tr>
            </thead>
            <draggable v-if="tabela.linha.length >= 1" v-model="tabela.linha" :element="'tbody'" class="dragArea" @end="pcoConfigStatusTabelaAlteraPosicao">
              <tr v-for="(linha, indexL) in tabela.linha" :key="'lin-' + indexL" :class="linha.status !== '1' ? 'pco-config-status-item-exc' : ''" v-show="((mostrarExcluido === false && linha.status === '1') || (mostrarExcluido === true))">
                <td 
                v-for="(coluna, indexC) in tabela.coluna" 
                :style="coluna.tipo === 'background' ? 'background: ' + linha.cor_fundo + '; color: ' + linha.cor_letra + ';' : ''"
                :key="'lin-' + indexL + '-col-' + indexC">
                  <template v-if="coluna.tipo === 'RF-Checkbox-Model'">
                    <RF-Checkbox-Model
                      :cpntChavesModel='coluna.chaveModel'
                      :cpntValue='linha[coluna.chave]'
                      :cpntChecked='tabela.checkbox'

                      @cpntUpdateModelLocal="pcoConfigOnCheckboxUpdateModel"
                      :cpntTime='time'
                    ></RF-Checkbox-Model>
                  </template>
                  <template v-else-if="coluna.tipo === 'mostrar'">
                    {{ linha[coluna.chave] === 's' ? 'Sim' : 'Não' }}
                  </template>
                  <span v-else v-html="linha[coluna.chave]"></span>
                </td>
              </tr>
            </draggable>
            <tbody v-else>
              <tr :key="'lin-0'">
                <td :key="'lin-0-col-0'" :colspan="tabela.coluna.length">Nenhum registro encontrado</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>

    <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
    <router-view :cpntFecharFormulario='pcoConfigStatusTabelaMontar'></router-view>
  </div>
</template>

<style scoped>
  .pco-config-status {
    padding-top: 30px !important;
  }
    .pco-config-status-tab {
      margin-top: 20px;
    }
      .rf-cpnt-group,
      .pco-config-status-buttons {
        display: inline-block;
      }
      .pco-config-status-buttons {
        /* vertical-align: -20px; */
        padding-left: 5px;
      }
        .pco-config-status-buttons > button {
          margin: 0px 2px;
        }
      .pco-config-status-tab > div > .pco-config-status-novo {
        margin: 10px 0px;
      }
    
    .tab-pco-config-status {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #d5dee5;
      font-size: var(--font-base-soma-24);
      color: #4D4D4D !important;
    }
      .tab-pco-config-status > thead > tr {
        font-size: var(--font-base-soma-11);
        background-color: #f4f9fe;
        text-decoration: none;
        border-top: 1px solid #d5dee5;
        border-bottom: 1px solid #d5dee5;
      }
        .tab-pco-config-status > thead > tr > th {
          padding: 5px;
          border-radius: 2px;
          color: #3875A5;
          font-weight: bold;
          text-align: center;
        }
          .tab-pco-config-status > thead > tr.buttons > th {
            text-align: left;
          }
            .tab-pco-config-status > thead > tr.buttons > th > button {
              margin: 1px 2px;
            }
          .tab-pco-config-status > thead > tr > th.buttons {
            border-left: 1px solid #d5dee5;
          }
          .tab-pco-config-status > thead > tr > th.titulos {
            border-right: 1px solid #d5dee5;
          }

  .tab-pco-config-status > tbody > tr {
    font-size: var(--font-base-soma-12);
    clear: both;
    background: #fff;
    text-decoration: none;
    border-top: 1px solid #d5dee5;
    border-bottom: 1px solid #d5dee5;
  }
  .tab-pco-config-status > tbody > tr.pco-config-status-item-exc {
    opacity: 0.7;
    background: #f3f3f3;
  }
    .tab-pco-config-status > tbody > tr.pco-config-status-item-exc > td {
      height: 1px;
    }
    .tab-pco-config-status > tbody > tr > td {
      padding: 1px 4px;
      height: 25px;
      color: var(--color-base-02);
      text-align: center;
    }
</style>

<style>
  .pco-config-status-tab > div > table > tbody > tr > .tab-pco-config-status-td-_cor {
    padding: 0px !important;
  }
    .pco-config-status-tab > div > table > tbody > tr > .tab-pco-config-status-td-_cor > span > table {
      height: 100%;
      width: 100%;
    }
</style>

<script>
  export default {
    components: {
      draggable: require('vuedraggable'),
      'RF-Checkbox-Tabela': () => import('@/components/rf-geral/checkbox/RF-Checkbox-Tabela.vue'),
      'RF-Checkbox-Model': () => import('@/components/rf-geral/checkbox/RF-Checkbox-Model.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        buttonForm: {},
        formulario: {},
        mostrarExcluido: false,
        tabela: {}
      }
    },
    mounted: function () {
      this.pcoConfigStatusIniciar()
    },
    methods: {
      pcoConfigStatusIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.pcoConfigStatusSetaStatusGeral('carregando')

        // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
        this.pcoConfigStatusFormIniciar()
      },
      pcoConfigOnCheckboxUpdateModelGeral: function () {
        // this.tabela.checkbox.length === this.tabela.linha.length
        switch (this.tabela.checkbox.length === this.tabela.linha.length) {
          case true:
            this.tabela.checkbox = []
            break

          case false:
            for (var key in this.tabela.linha) {
              this.tabela.checkbox.push(this.tabela.linha[key].id)
            }
            break
        }

        // SETA SE O BOTÃO GERAL TA MARCADO OU NÃO
        this.tabela.checkboxGeral = (this.tabela.checkbox.length === this.tabela.linha.length ? [ 'id' ] : [])

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      pcoConfigOnCheckboxUpdateModel: function (event) {
        // IMPORTA A FUNÇÃO PARA REMOVER A CONTA DO CS
        const CPNT_UPDATE_MODEL = require('@/assets/js/Funcoes-Gerais.js').CPNT_UPDATE_MODEL

        // CHAMA A FUNÇÃO PARA REMOVER A CONTA DO LS_WEB
        CPNT_UPDATE_MODEL(this, event)

        // SETA SE O BOTÃO GERAL TA MARCADO OU NÃO
        this.tabela.checkboxGeral = (this.tabela.checkbox.length === this.tabela.linha.length ? [ 'id' ] : [])

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      pcoConfigStatusSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      pcoConfigStatusFormIniciar: function (id = '') {
        var self = this

        // INICIA OS VALORES DO FORMULARIO
        self.formulario = {
          buttons: []
        }

        // SETA QUAL É O ID QUE VAI SER SELECIONADO
        if ([ '', null, undefined ].indexOf(id) !== -1) {
          if (self.$route.name === 'pco_config_status_form' && [ '', null, undefined ].indexOf(self.$route.params.id) === -1) {
            id = self.$route.params.id
          } else if (self.$route.name === 'pco_config_status_form_item' && [ '', null, undefined ].indexOf(self.$route.params.tipo) === -1) {
            id = self.$route.params.tipo
          }
        }

        // SETA O CAMPO ESPECIE
        self.formulario.tipo = {
          tipo: 'select2',
          status: '',
          tamanho: 2,
          id: 'pco-config-status-tipo',
          nome: 'Lista de Status',
          keyValue: 'id',
          keyMostra: [ 'nome', '_status' ],
          value: '',
          options: [],
          optionsOriginal: [],
          optionInicialNome: '',
          itemExcluido: false,
          onChange: function (value) {
            // SETA O VALOR RECEBIDO
            self.formulario.tipo.value = value

            // VERIFICA SE O ITEM FOI EXCLUIDO
            self.formulario.tipo.itemExcluido = self.formulario.tipo.options.filter(item => item.id === value)[0].status !== '1'

            // VERIFICA SE DEVE OU NÃO MOSTRAR AS OPÇÕES
            for (var index in self.formulario.buttons) {
              self.formulario.buttons[index].mostrar = (self.formulario.buttons[index].tipo === 'reativar' ? self.formulario.tipo.itemExcluido : !self.formulario.tipo.itemExcluido)
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA CARREGAR AS LINHAS
            Object.keys(self.tabela).length >= 1 ? self.pcoConfigStatusTabelaCarregarLinhas() : self.pcoConfigStatusTabelaIniciar()
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA CARREGAR OS TIPOS
        self.pcoConfigStatusBuscarTipos(id, function () {
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // SETA O STATUS DA PAGINA
          self.pcoConfigStatusSetaStatusGeral('')

          // SETA OS BUTTONS
          self.formulario.buttons = [
            { status: '', id: 'pco-config-status-novo', tipo: 'icone', icone: { tipo: 'ico-mais' }, class: 'btn btn-info btn-sm', onClick: function () {
              self.$router.push({ name: 'pco_config_status_form', params: { id: 0 } })
            } },
            { status: '', id: 'pco-config-status-editar', tipo: 'editar', class: 'btn btn-warning btn-sm', onClick: function () {
              self.$router.push({ name: 'pco_config_status_form', params: { id: self.formulario.tipo.value } })
            } },
            { status: '', id: 'pco-config-status-excluir', tipo: 'excluir', class: 'btn btn-danger btn-sm', onClick: self.pcoConfigStatusExcluirStatus },
            { status: '', id: 'pco-config-status-reativar', tipo: 'reativar', class: 'btn btn-info btn-sm', mostrar: false, onClick: self.pcoConfigStatusExcluirStatus }
          ]

          // SETA O BOTÃO PARA APRESENTAR
          self.buttonForm = {
            status: '',
            id: 'pco-config-status-novo',
            texto: 'Novo Status',
            class: [ 'btn', 'btn-info', 'btn-md' ],
            onClick: function () {
              self.$router.push({ name: 'pco_config_status_form_item', params: { tipo: self.formulario.tipo.value, id: 0 } })
            }
          }

          // CHAMA A FUNÇÃO PARA INICIAR A TABELA
          self.pcoConfigStatusTabelaMontar()
        })
      },
      pcoConfigStatusBuscarTipos: function (id = null, callback = null, qtdeTotal = -1) {
        var self = this

        if (qtdeTotal === -1) {
          // LIMPA TODAS AS OPÇÕES EXISTENTES
          self.formulario.tipo.optionsOriginal = []

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }

        if (qtdeTotal === -1 || self.formulario.tipo.optionsOriginal.length < qtdeTotal) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: self.formulario.tipo.optionsOriginal.length, qty: 1000 }, field: { id: null, nome: null, status: null }, order: { nome: 'asc' } }

          // FAZ A BUSCA NA API
          self.$store.state.comunicaAPI('/con-processo/config/status/get/', 'GET', queryGet, function (apiSuccess) {
            // SETA OS VALORES RECEBIDOS
            self.formulario.tipo.optionsOriginal = self.formulario.tipo.optionsOriginal.concat(apiSuccess.data)
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
            self.pcoConfigStatusBuscarTipos(id, callback, Number(apiSuccess.countAll))
          }, self.pcoConfigStatusSetaStatusGeral)
        } else {
          if ([ null, undefined ].indexOf(id) === -1) {
            // SETA O TIPO DE REGISTRO QUE ESTA SENDO EDITADO
            if (id !== '') {
              self.formulario.tipo.value = id
            } else {
              var opcoes = self.formulario.tipo.optionsOriginal.filter(item => item.status === '1')
              self.formulario.tipo.value = opcoes.length >= 1 ? opcoes[0].id : ''
            }
          }

          for (var key in self.formulario.tipo.optionsOriginal) {
            // INICIA O VALOR DA CHAVE
            self.formulario.tipo.optionsOriginal[key]._status = ''

            // SETA A INFORMAÇÃO QUE ESTA EXCLUIDO O ITEM
            if (self.formulario.tipo.optionsOriginal[key].status !== '1') {
              self.formulario.tipo.optionsOriginal[key]._status = ' <b>[Excluído]</b>'
            }
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK SE ELA EXISTIR
          if (callback !== null) {
            callback()
          }
        }
      },

      pcoConfigStatusTabelaMontar: function (atualizar = true, id = null, dados = {}) {
        if (atualizar === true) {
          if ([ '', null, undefined ].indexOf(id) === -1) {
            // PEGA O ID DA LISTA
            var lista = [ '', null, undefined ].indexOf(dados.id_pco_status) === -1 ? dados.id_pco_status : id

            // SETA O STATUS DA PAGINA
            this.pcoConfigStatusSetaStatusGeral('carregando')

            // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
            this.pcoConfigStatusFormIniciar(lista)
          } else if ([ '', null, undefined ].indexOf(this.formulario.tipo.value) === -1) {
            this.pcoConfigStatusTabelaIniciar()
          } else {
            // LIMPA OS DADOS EXISTENTES
            this.tabela = {}
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        }
      },
      pcoConfigStatusTabelaIniciar: function () {
        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        this.tabela = {
          status: 'carregando',
          id: 'pco-config-status',
          acoes: {
            buttons: []
          },
          linha: [],
          montarTabelaCompleta: false,
          checkboxGeral: [],
          checkbox: [],
          linhasOriginal: []
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INFORMA TODAS AS COLUNAS DA TABELA
        this.tabela.coluna = [
          { mPer: 2, chave: 'id', nome: 'Cód.' },
          { mPer: 2, chave: '_nome', nome: 'Nome' },
          { mPer: 2, chave: 'cor_fundo', nome: 'Cor', tipo: 'background' },
          { mPer: 2, chave: 'painel_mostrar', nome: 'Mostrar no painel', tipo: 'mostrar' },
          // { mPer: 2, chave: 'posicao', nome: 'posicao' },
          { mPer: 2, chave: '_last_at', nome: 'Última Alteração' }
        ]

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA CARREGAR AS LINHAS
        this.pcoConfigStatusTabelaCarregarLinhas()
      },
      pcoConfigStatusTabelaCarregarLinhas: function () {
        var self = this

        // LIMPA OS CHECKBOX SELECIONADOS
        self.tabela.checkbox = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA CARREGAR AS LINHAS
        self.pcoConfigStatusTabelaBuscarLinhas(function () {
          // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
          self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
            // SETA OS DADOS RECEBIDOS PARA TABELA
            self.tabela = tabelaSuccess

            // REALIZA O FOR PARA CRIAR OS CAMPOS PERSONALIZADOS
            for (var key in self.tabela.linha) {
              // CONVERTE O VALOR PARA NUMERO
              self.tabela.linha[key].posicao = Number(self.tabela.linha[key].posicao)

              // MONTA A COLUNA ULTIMA ALTERAÇÃO
              if (self.tabela.linha[key].hasOwnProperty('cor')) {
                var cor = self.tabela.linha[key].cor.substring(1).split('')
                if (cor.length == 3) {
                  cor = [cor[0], cor[0], cor[1], cor[1], cor[2], cor[2]]
                }
                cor = '0x' + cor.join('')

                self.tabela.linha[key].cor_letra = (((parseInt((cor>>16)&255) * 299) + (parseInt((cor>>8)&255) * 587) + (parseInt(cor&255) * 114)) / 1000) >= 127.5 ? '#000000' : '#ffffff'
                self.tabela.linha[key].cor_fundo = self.tabela.linha[key].cor
              }

              // PEGA O NOME RECEBIDO
              self.tabela.linha[key]._nome_check = self.tabela.linha[key].nome

              // CONVERTE PARA MINUSCULO O VALOR RECEBIDO
              self.tabela.linha[key]._nome_check = self.tabela.linha[key]._nome_check.toUpperCase()

              // PEGA A POSIÇÃO DA PALAVRA ENTREGE
              self.tabela.linha[key]._nome_check_posicao = self.tabela.linha[key]._nome_check.indexOf('ENTREGUE')

              // VERIFICA SE ENCONTROU A PALAVRA ENTREGUE
              if (self.tabela.linha[key]._nome_check_posicao !== -1) {
                // PEGA A PALAVRA ORIGINAL
                var palavra = self.tabela.linha[key].nome.substring(self.tabela.linha[key]._nome_check_posicao, (self.tabela.linha[key]._nome_check_posicao + 8))

                // ATUALIZA O NOME RECEBIDO
                self.tabela.linha[key].nome = self.tabela.linha[key].nome.replace(palavra, '<span style="cursor: help; color: #3342ff; font-weight: bold;" title="A alteração para este status na Venda atualiza a data de entrega.">' +  palavra + '</span>')
              }

              // SETA O NOME DO STATUS
              self.tabela.linha[key]._nome = self.tabela.linha[key].nome
              
              // VERIFICA O STATUS DA LINHA
              if (self.tabela.linha[key].status !== '1') {
                self.tabela.linha[key]._nome += ' <b>[Excluído]</b>'
              }

              // MONTA A COLUNA ULTIMA ALTERAÇÃO
              if (self.tabela.linha[key].hasOwnProperty('last_user_usuario')) {
                self.tabela.linha[key]._last_at = self.tabela.linha[key].last_user_usuario + '<br/>' + self.tabela.linha[key].last_at_ptbr
              }
            }

            // // SALVA AS LINHA RECEBIDAS
            // self.tabela.linhasOriginal = JSON.parse(JSON.stringify(self.tabela.linha))

            // CHAMA A FUNÇÃO PARA VER QUAL LINHAS DEVE MOSTRAR
            self.pcoConfigStatusTabelaVerificaLinhaMostrar()

            // SETA O STATUS DA TABELA
            self.tabela.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }, self.pcoConfigStatusSetaStatusGeral)
        })
      },
      pcoConfigOnCheckboxMostrarExcluidos: function (value) {
        // CHAMA A FUNÇÃO PARA ALTERAR O VALOR DO CAMPO
        if (this.formulario.tipo.itemExcluido === true && this.mostrarExcluido === true && value === false) {
          // PEGA AS LINHAS QUE NÃO ESTA EXCLUIDAS
          var opcoes = this.formulario.tipo.optionsOriginal.filter(item => item.status === '1')

          // CHAMA A FUNÇÃO PARA ATUALIZAR OS VALORES
          this.formulario.tipo.onChange(opcoes.length >= 1 ? opcoes[0].id : '')
        } else {
          // SETA O VALOR ATUALIZADO RECEBIDO
          this.mostrarExcluido = value
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
  
          // CHAMA A FUNÇÃO PARA VER QUAL LINHAS DEVE MOSTRAR
          this.pcoConfigStatusTabelaVerificaLinhaMostrar()
        }
      },
      pcoConfigStatusTabelaVerificaLinhaMostrar: function () {        
        switch (this.mostrarExcluido) {
          case false:
            // MOSTRA APENAS OS STATUS ATIVADOS
            // // this.tabela.linha = this.tabela.linhasOriginal.filter(item => item.status === '1')

            // SETA AS OPÇÕES DO FILTRO
            this.formulario.tipo.options = this.formulario.tipo.optionsOriginal.filter(item => item.status === '1')
            break
        
          default:
            // MOSTRA TODOS OS STATUS, INCLUSIVE OS EXCLUIDOS
            // this.tabela.linha = this.tabela.linhasOriginal

            // SETA AS OPÇÕES DO FILTRO
            this.formulario.tipo.options = this.formulario.tipo.optionsOriginal
            break
        }

        if (this.formulario.tipo.itemExcluido === true) {
          // OCULTA TODOS O BUTTONS
          this.tabela.acoes.buttons = []

          // REMOVE A COLUNA CHECKBOX
          this.tabela.coluna = this.tabela.coluna.filter(item => item.tipo !== 'RF-Checkbox-Model')
        } else {
          // OCULTA TODOS O BUTTONS
          this.tabela.acoes.buttons = [
            {  status: '', id: this.tabela.id + '-bt-acoes-editar', tipo: 'editar', class: 'btn btn-warning btn-sm', mostrar: false, onClick: this.pcoConfigStatusTabelaEditar },
            {  status: '', id: this.tabela.id + '-bt-acoes-excluir', tipo: 'excluir', class: 'btn btn-danger btn-sm', mostrar: false, onClick: this.pcoConfigStatusExcluirStatus },
            {  status: '', id: this.tabela.id + '-bt-acoes-reativar', tipo: 'reativar', class: 'btn btn-info btn-sm', mostrar: false, onClick: this.pcoConfigStatusExcluirStatus }
          ]

          // ADICIONA A COLUNA CHECKBOX
          if (this.tabela.coluna.filter(item => item.tipo === 'RF-Checkbox-Model').length === 0) {
            this.tabela.coluna.unshift({ mPer: 3, tipo: 'RF-Checkbox-Model', chave: 'id', chaveModel: [ 'tabela', 'checkbox' ] })
          }

          // VERIFICA SE DEVE OU NÃO MOSTRAR AS OPÇÕES
          for (var index in this.tabela.acoes.buttons) {
            switch (this.tabela.acoes.buttons[index].tipo) {
              case 'reativar':
                this.tabela.acoes.buttons[index].mostrar = this.tabela.linha.filter(item => item.status !== '1').length >= 1
                break
  
              default:
                this.tabela.acoes.buttons[index].mostrar = !this.formulario.tipo.itemExcluido
                break
            }
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      pcoConfigStatusTabelaBuscarLinhas: function (callback = null, qtdeTotal = -1) {
        var self = this

        if (qtdeTotal === -1 || self.tabela.linha.length < qtdeTotal) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: (qtdeTotal === -1 ? 0 : self.tabela.linha.length), qty: 1000 }, field: { id: null, nome: null, id_pco_status: null, posicao: null, painel_mostrar: null, cor: null, status: null, last_at: null, last_user: { j: { usuario: null } } }, order: { posicao: 'asc' } }

          // SETA O WHERE
          queryGet.where = { aAnd: [ { f: 'id_pco_status', o: '=', v: self.formulario.tipo.value } ] }

          // FAZ A BUSCA NA API
          self.$store.state.comunicaAPI('/con-processo/config/sta-item/get/', 'GET', queryGet, function (apiSuccess) {
            // SETA OS VALORES RECEBIDOS
            if (qtdeTotal === -1) {
              self.tabela.linha = apiSuccess.data
            } else {
              self.tabela.linha = self.tabela.linha.concat(apiSuccess.data)
            }
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
            self.pcoConfigStatusTabelaBuscarLinhas(callback, Number(apiSuccess.countAll))
          }, self.pcoConfigStatusSetaStatusGeral)
        } else if (callback !== null) {
          callback()
        }
      },
      pcoConfigStatusTabelaAlteraPosicao: function (event) {
        // VERIFICA SE FOI ALTERADO A POSIÇÃO
        if (event.oldIndex !== event.newIndex) {
          var self = this

          // INICIA O FORMULARIO
          var formData = { lot: [ { id: self.tabela.linha[event.newIndex].id, posicao: (event.newIndex + 1) } ] }

          // FAZ A BUSCA NA API
          self.$store.state.comunicaAPI('/con-processo/config/sta-item', 'PUT', formData, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
              // CHAMA A FUNÇÃO PARA CARREGAR AS LINHAS
              self.pcoConfigStatusTabelaCarregarLinhas()
            })
          }, self.pcoConfigStatusSetaStatusGeral)
        }
      },
      pcoConfigStatusSetarStatusButton: function (id, status = '') {
        // SETA O STATUS DE CARREGANDO PARA O BOTÃO
        switch (id) {
          case 'pco-config-status-excluir':
            this.formulario.buttons[2].status = status
            break
        
          case 'pco-config-status-bt-acoes-excluir':
            this.tabela.acoes.buttons[1].status = status
            break

          case 'pco-config-status-bt-acoes-reativar':
            this.tabela.acoes.buttons[2].status = status
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      pcoConfigStatusExcluirStatus: function (id) {
        var _self = this

        var callback = null
        var registro = []
        var mensagem = ''
        var route = ''
        var method = 'DELETE'

        switch (id) {
          case 'pco-config-status-excluir':
            callback = function () {
              // SETA O STATUS DA PAGINA
              _self.pcoConfigStatusSetaStatusGeral('carregando')

              // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
              _self.pcoConfigStatusFormIniciar('')
            }
            route = '/con-processo/config/status'
            registro = [ this.formulario.tipo.value ]
            mensagem = 'Deseja realmente excluir está lista de status?'
            break

          case 'pco-config-status-reativar':
            callback = function () {
              // SETA O STATUS DA PAGINA
              _self.pcoConfigStatusSetaStatusGeral('carregando')

              // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
              _self.pcoConfigStatusFormIniciar('')
            }
            route = '/con-processo/config/status/reativar'
            registro = [ this.formulario.tipo.value ]
            mensagem = 'Deseja realmente reativar está lista de status?'
            method = 'PUT'
            break
        
          case 'pco-config-status-bt-acoes-excluir':
            callback = this.pcoConfigStatusTabelaCarregarLinhas
            route = '/con-processo/config/sta-item'
            registro = this.tabela.checkbox
            mensagem = 'Deseja realmente excluir o(s) status(s) selecionado(s)?'
            break

          case 'pco-config-status-bt-acoes-reativar':
            callback = this.pcoConfigStatusTabelaCarregarLinhas
            route = '/con-processo/config/sta-item/reativar'
            registro = this.tabela.checkbox
            mensagem = 'Deseja realmente reativar o(s) status(s) selecionado(s)?'
            method = 'PUT'
            break
        }

        switch (registro.length) {
          case 0:
            this.$store.state.msgWarn('WEB [400]: É necessario selecionar um registro par continuar.', 'warning')
            break
        
          default:
            if (callback !== null && window.confirm(mensagem)) {
              var self = this
    
              // SETA O STATUS DE CARREGANDO PARA O BOTÃO
              self.pcoConfigStatusSetarStatusButton(id, 'carregando')
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
    
              // CRIA O FORMUARIO QUE SERÁ ENVIADO PARA API
              var formData = {}
              
              // VERIFICA O FORMATO QUE DEVE SER ENVIADO PARA API
              if ([ 'pco-config-status-bt-acoes-reativar', 'pco-config-status-reativar' ].indexOf(id) === -1) {
                formData = { lot: [] }
      
                // ADICIONA OS CHECKBOX MARCADOS
                for (var key in registro) {
                  formData.lot.push({ id: registro[key] })
                }
              } else {
                formData.j_id = JSON.stringify(registro)
              }
    
              // CHAMA FUNÇÃO PARA COMUNICAR COM API
              self.$store.state.comunicaAPI(route, method, formData, function (apiSuccess) {
                self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
                  // SETA O STATUS DE CARREGANDO PARA O BOTÃO
                  self.pcoConfigStatusSetarStatusButton(id, '')

                  // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
                  self.time = new Date().getTime()
    
                  // CHAMA A FUNÇÃO PARA CARREGAR AS LINHAS
                  callback()
                })
              }, function (apiError) {
                // SETA O STATUS DE CARREGANDO PARA O BOTÃO
                self.pcoConfigStatusSetarStatusButton(id, '')
    
                // ALTERA O STATUS
                self.tabela.status = apiError
    
                // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
                self.time = new Date().getTime()
              })
            }
            break;
        }
      },
      pcoConfigStatusTabelaEditar: function () {
        switch (this.tabela.checkbox.length) {
          case 0:
            this.$store.state.msgWarn('WEB [400]: É necessario selecionar um registro par continuar.', 'warning')
            break

          case 1:
            this.$router.push({ name: 'pco_config_status_form_item', params: { tipo: this.formulario.tipo.value, id: (this.tabela.checkbox.length === 1 ? this.tabela.checkbox[0] : window.btoa(JSON.stringify(this.tabela.checkbox))) } })
            break
        
          default:
            this.$store.state.msgWarn('WEB [400]: Só é possivel editar um registro por vez.', 'warning')
            break;
        }
      }
    },
    watch: {
    }
  }
</script>
